import api from "@/api/Axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

const initialState = {
  loading: false,
  country: null,
  error: null,
  cached: false,
  timestamp: null,
};

export const getUserLocation = createAsyncThunk(
  "userLocation/getUserLocation",
  async (_, { rejectWithValue }) => {
    try {
      const { data } = await api.get("/home/userlocation/");

      if (data?.status === 200) {
        return {
          country: data?.data?.country || "US",
          cached: false,
          timestamp: Date.now(),
        };
      } else {
        return rejectWithValue("Failed to fetch location");
      }
    } catch (error) {
      return rejectWithValue(error.message || "Location detection failed");
    }
  }
);

const userLocationSlice = createSlice({
  name: "userLocation",
  initialState,
  reducers: {
    setUserLocation: (state, action) => {
      state.country = action.payload.country;
      state.cached = action.payload.cached || false;
      state.timestamp = action.payload.timestamp || Date.now();
      state.error = null;
      state.loading = false;
    },
    clearUserLocation: (state) => {
      state.country = null;
      state.cached = false;
      state.timestamp = null;
      state.error = null;
      state.loading = false;
    },
    setLocationError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUserLocation.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getUserLocation.fulfilled, (state, action) => {
        state.loading = false;
        state.country = action.payload.country;
        state.cached = action.payload.cached;
        state.timestamp = action.payload.timestamp;
        state.error = null;
      })
      .addCase(getUserLocation.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { setUserLocation, clearUserLocation, setLocationError } =
  userLocationSlice.actions;
export default userLocationSlice.reducer;
